<template>
    <div class="container-openserver">
        <!-- 开通支付功能 -->
        <p class="sub-title">开通支付功能</p>
        <!-- 国内 -->
        <div class="service-item">
            <div class="service-title">服务</div>
            <div class="content-detail">
                <div>
                    服务名称：
                    <span>{{serviceInfo && serviceInfo.serviceName || '无'}}</span>
                </div>
                <div>
                    APPID：
                    <span>{{serviceInfo && serviceInfo.appId || '无'}}</span>
                </div>
                <div>
                    服务状态：
                    <span>{{serviceInfo && serviceInfo.serviceStatus || '无'}}</span>
                </div>
                <div>
                    <el-button
                        size="mini"
                        @click="showDetail()">编辑资产服务
                    </el-button>
                </div>
            </div>
            <div class="card-box">
                <div class="card">
                    <img class="logo" src="./img/common.png" alt="">
                    <p>用户资产</p>
                    <div class="desc">
                        <p></p>
                    </div>
                    <el-button type="primary">已开通</el-button>
                </div>
            </div>
        </div>
        <div class="service-item" v-if="withdrawChannels.aliChannel || withdrawChannels.wxChannel || withdrawChannels.bankChannel">
            <div class="service-title">提现渠道</div>
            <div v-if="withdrawChannels && withdrawChannels.aliChannel">
                <div class="content-title">支付宝</div>
                <div class="content-detail">
                    <div>
                        账户余额：
                        <span>{{withdrawChannels.aliChannel.balanceAmount || '无'}}元</span>
                    </div>
                    <div>
                        预警金额：
                        <span>{{withdrawChannels.aliChannel.warnAmount || '无'}}元</span>
                    </div>
                    <div>
                        预警邮箱：
                        <span>{{withdrawChannels.aliChannel.warnEmails || '无'}}</span>
                    </div>
                </div>
            </div>
            <div v-if="withdrawChannels && withdrawChannels.wxChannel">
                <div class="content-title">微信</div>
                <div class="content-detail">
                    <div>
                        预算剩余：
                        <span>{{withdrawChannels.wxChannel.balanceAmount || '无'}}元</span>
                    </div>
                    <div>
                        预警金额：
                        <span>{{withdrawChannels.wxChannel.warnAmount || '无'}}元</span>
                    </div>
                    <div>
                        预警邮箱：
                        <span>{{withdrawChannels.wxChannel.warnEmails || '无'}}</span>
                    </div>
                </div>
            </div>
            <div v-if="withdrawChannels && withdrawChannels.bankChannel">
                <div class="content-title">银行卡</div>
                <div class="content-detail">
                    <div>
                        预算剩余：
                        <span>{{withdrawChannels.bankChannel.balanceAmount || '无'}}元</span>
                    </div>
                    <div>
                        预警金额：
                        <span>{{withdrawChannels.bankChannel.warnAmount || '无'}}元</span>
                    </div>
                    <div>
                        预警邮箱：
                        <span>{{withdrawChannels.bankChannel.warnEmails || '无'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="service-item"
            v-if="serviceInfo.appkey || serviceInfo.dealId || serviceInfo.platformPublicKey">
            <div class="service-title">开发者信息</div>
            <div>
                <div class="content-detail formPublicKey">
                    <div>
                        <span class="management-gray ">dealld：</span>
                        <span>{{ serviceInfo.dealId || '无'}}</span>
                    </div>
                </div>
                <div class="content-detail formPublicKey" >
                    <div>
                        <span class="management-gray">平台公钥：</span>
                        <div class="publickey"><span>{{ serviceInfo.platformPublicKey || '无' }}</span></div>
                    </div>
                </div>
                <div class="content-detail  formPublicKey">

                    <div>
                        <span class="management-gray">APP KEY：</span>
                        <span>{{ serviceInfo.appkey|| '无' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    withdrawAppInfo
} from "../../api/apiMap/index.js";
export default {
    mounted() {
        const appId = this.$route.query.appId || '';
        this.appId = appId;
        this.init(appId);
	},
    data() {
        return {
            appId: '',
            serviceInfo: {
                aiBankJointId: "",
                wechatJointId: "",
            },
            withdrawChannels: {},
            wechat: 0, 
            aiBank: 0,
        };
    },
    methods: {
        init() {
            withdrawAppInfo({
                appId: this.appId,
            }).then((result) => {
                const {appId, serviceName, serviceStatus, withdrawChannels, appkey, dealId, platformPublicKey } = result.data;
                this.serviceInfo = {
                    "appId": appId,
                    "serviceName": serviceName,
                    "serviceStatus": serviceStatus,
                    "appkey": appkey,
                    "dealId": dealId,
                    "platformPublicKey": platformPublicKey
                };
                this.withdrawChannels = withdrawChannels;
            })
        },
        openServer() {
            this.$router.push({
                path: "/createServer",
                query: {
                    appId: this.appId
                }
            })
        },
        openCommonServer() {
            // 已创建，去编辑
            if (this.appId && this.serviceInfo && this.serviceInfo.aiBankStatus !== '未开通') {
                let url = "https://trade.baidu.com/feplatform/myserve/home.html#!/edit-serve?currentpage=1&haveApproved=1&pagesize=10";
                if (this.appId) {
                    url += "&appId=" + this.appId;
                }
                location.href = url;
            } else {
                // 未创建，去创建
                let url = "https://trade.baidu.com/feplatform/myserve/home.html#!/create-serve?currentpage=1&haveApproved=1&pagesize=10";
                if (this.appId) {
                    url += "&appId=" + this.appId;
                }
                location.href = url;
            }
        },
        showDetail() {
            this.$router.push({
                path: "/createAsset",
                query: {
                    appId: this.appId
                }
            })
        }
    }
};
</script>
<style lang="less">
.container-openserver{
    .sub-title{
        border-left: 10px solid #4D7DfD;
        color: #4D7DfD;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        font-weight: 600;
        padding-left: 20px;
        margin-bottom: 20px;
    }
    .content-title{
        background: #eef5ff;
        padding: 20px;
    }
    .service-item{
        border: 2px solid #e6e6e6;
        border-radius: 30px;
        padding: 60px;
        margin-bottom: 20px;
        position: relative;
        .content-detail{
            display: flex;
            div{
                .management-gray{
                    color: #9D9D9D;

                }
                line-height: 80px;
                font-weight: 600;
                font-size: 14px;
                margin-right: 50px;
                span{
                    font-weight: 400;
                }

            }
        }
        .formPublicKey{
            div{
                max-width: 100%;
                display: flex;
                .management-gray{
                    width: 100px;
                }
                .publickey{
                    width: 80%;
                    word-wrap: break-word;
                    display: inline-block;
                    max-width: 100%;
                    font-weight: 400;
                }
            }
        }
        .service-title{
            position: absolute; /* 绝对定位以便放置在 service-title 内部 */
            top: 0;
            left: 0;
            width: 150px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background-color: #4D7DfD;
            color: white;
            clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
        }
    }
    .note{
        background: #fee9eb;
        padding: 20px;
    }
    .card-box{
        display: flex;
        .card{
            text-align: center;
            border: 2px solid #e6e6e6;
            border-radius: 30px;
            width: 300px;
            padding: 60px 20px;
            margin: 20px;
            p{
                margin-bottom: 20px;
            }
            .desc{
                height: 40px;
                position: relative;
                margin-bottom: 20px;
                p{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 14px;
                    font-weight: 600;
                    margin: 0;
                    width: 100%;
                }
            }
            .logo{
                height: 40px;
                width: 40px;
                margin-bottom: 20px;
            }
        }
    }
}
</style>
